// extracted by mini-css-extract-plugin
export default {"text":"TextFilePreview_text__EmUGf","message":"TextFilePreview_message__XwhLL"};